import TreeModel from 'tree-model'

export default class AttributeTree {
  constructor () {
    this._treeModel = new TreeModel()
    this.droppedNodes = null
    this.root = this._treeModel.parse({
      name: 'Data Sources',
      children: []
    })
  }

  addDataSource (dataSource) {
    const node = this._treeModel.parse(dataSource)
    this.root.addChild(node)
  }

  addBackDroppedDatasets () {
    if (this.droppedNodes) {
      let listOfAllNodes = []
      for (let n of this.root.children) {
        listOfAllNodes.push(n)
      }
      for (let n of listOfAllNodes) {
        n.drop()
      }
      listOfAllNodes = [...listOfAllNodes, ...this.droppedNodes]
      listOfAllNodes.sort((a, b) => {
        return a.model.name.toLowerCase().localeCompare(b.model.name.toLowerCase())
      })
      for (let d of listOfAllNodes) {
        this.root.addChild(d)
      }
      // make sure to set the droppedNodes back to null
      this.droppedNodes = null
    }
  }

  dropNodes (datasets) {
    let nodesToDrop = []
    for (let node of this.root.children) {
      if (!datasets.includes(node.model.id)) {
        nodesToDrop.push(node)
      }
    }
    for (let n of nodesToDrop) {
      n.drop()
    }
    if (nodesToDrop.length > 0) {
      this.droppedNodes = nodesToDrop
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/attributePanel/models/attributeTree.js